// @ts-strict-ignore
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArticleCollectionVO, ArticleVO } from '@article/model/vo/article.vo';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { ArrayUtils } from '@shared/util/array-utils';
import { ArticlePreviewUtils } from '@article/util/article-preview.utils';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CookieStorage } from '@shared/cookie-storage';
import { AddArticleToCollectionMode } from './add-article-to-collection-mode.enum';
import { CollectionService } from '../../service/collection.service';

/**
 * The component to add an article to a library
 */
@Component({
  standalone: false,
  selector: 'add-article-to-collection',
  templateUrl: './add-article-to-collection.component.html',
})
export class AddArticleToCollectionComponent implements OnInit {
  public readonly AddArticleToCollectionMode = AddArticleToCollectionMode;
  public articleImage: string;

  @Input() public mode: AddArticleToCollectionMode = AddArticleToCollectionMode.SINGLE;
  @Input() public articles: ArticleVO[] = [];
  @Input() public articleCollections: ArticleCollectionVO[];
  @Input() public selectedArticleCollection: ArticleCollectionVO;
  @Input() public displayAllArticleNos: boolean = false;
  @Output() public finish = new EventEmitter<ArticleCollectionVO | null>();

  constructor(
    private bsModalRef: BsModalRef,
    private localeResourceManager: LocaleResourceManager,
    private collectionService: CollectionService,
    private _cookieStorage: CookieStorage
  ) {}

  public ngOnInit(): void {
    if (this.mode === AddArticleToCollectionMode.SINGLE) {
      this.articleImage = ArticlePreviewUtils.getPreviewImage(this.articles[0]);
    }
    if (ArrayUtils.isNotEmpty(this.articleCollections)) {
      const collectionFromCookie = this.articleCollections.find((collection) => {
        return collection.id === this._cookieStorage.lastSelectedArticleCollectionId;
      });
      const favoriteCollection = this.articleCollections.find((collection) => {
        return collection.type === ArticleCollectionVO.TYPE_FAVORITES;
      });

      if (collectionFromCookie || favoriteCollection) {
        this.selectedArticleCollection = collectionFromCookie ? collectionFromCookie : favoriteCollection;
      } else {
        this.selectedArticleCollection = this.articleCollections[0];
      }
    }
  }

  public close(collection: ArticleCollectionVO = null): void {
    this.bsModalRef.hide();
    this.finish.emit(collection);
  }

  public getArticleCollectionLabel(name: string): String {
    return this.localeResourceManager.getResolvedString(name);
  }

  public add(): void {
    if (!this.selectedArticleCollection) {
      return;
    }
    let articleIds: number[] = this.selectedArticleCollection.articleIds;
    const articleIdsToAdd: number[] = this.articles.map((a) => a.identity);
    if (ArrayUtils.isEmpty(articleIds)) {
      articleIds = articleIdsToAdd;
    } else {
      ArrayUtils.mergeArrays(articleIds, articleIdsToAdd);
    }
    this.selectedArticleCollection.articleIds = articleIds;
    this._cookieStorage.lastSelectedArticleCollectionId = this.selectedArticleCollection.id;
    this.close(this.selectedArticleCollection);
    this.collectionService.notifyCollectionUpdated();
  }

  public handleMissingImage(event: Event) {
    (event.target as HTMLImageElement).classList.add('d-none');
  }
}
